import PUserRootLayout from "./PUserRootLayout";

export default PUserRootLayout;
